import {Nullable, AgencyFeedManagementListing} from 'common/types';
import {
  FETCH_AGENCYFEED_MANAGEMENT_LISTING_FAILURE,
  FETCH_AGENCYFEED_MANAGEMENT_LISTING_REQUEST,
  FETCH_AGENCYFEED_MANAGEMENT_LISTING_SUCCESS,
  AgencyFeedAction,
} from '../types';

interface State {
  data: Nullable<AgencyFeedManagementListing>;
  isFetching: boolean;
  error: Nullable<Error>;
}

const initialState: State = {
  data: null,
  isFetching: false,
  error: null,
};

export const managementReducer = (
  state: State = initialState,
  action: AgencyFeedAction
) => {
  switch (action.type) {
    case FETCH_AGENCYFEED_MANAGEMENT_LISTING_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };

    case FETCH_AGENCYFEED_MANAGEMENT_LISTING_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
      };
    case FETCH_AGENCYFEED_MANAGEMENT_LISTING_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
};
